/* eslint-disable no-mixed-operators */
/* eslint-disable prefer-destructuring */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/prefer-for-of */
import {
    NAME_TOOL_HEIGHT,
    ToolbarType,
} from '@src/js/constant';
import {
    SINGLE_TOOLBAR_HEAD_HEIGHT,
    LEFT_BAR_WIDTH,
    STATUS_BAR_HEIGHT,
    DOUBLE_TOOLBAR_HEAD_HEIGHT,
    RULER_LENGTH,
} from '@editor/src/js/constants';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { GroupUIEdge } from '@editor/src/page/index/components/canvas/element-types/group-element/constant';
import { getFrameAfterRotate } from '@src/slide/infrastructure/module/independent/graphic';
import { isNumberEqual } from '@src/slide/infrastructure/module/independent/unit';
import { DisplayObject, ReadonlyBounds } from '@tencent/alloy-renderer';
import { IBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/base-model.interface';
import { IMasterLayoutEditService } from '@src/slide/application/service/master-layout-edit-service/master-layout-edit-service.interface';
import { ITextRulerManager } from '@src/slide/application/service/text-ruler-manager/core/index.interface';
import {
    ICanvasSizeHandler,
} from '@src/slide/application/service/canvas-component/core/base/canvas-size-handler/interface';
import {
    IPcCanvasServiceDelegates,
} from '@src/slide/application/service/canvas-component/core/pc/pc-canvas-service.interface';
import { isDomCompatibleElement } from '@src/slide/domain/ui-model/elements/element-judge';
import { getHeightFixedByNoteHeight } from '@src/slide/application/service/note-area-component/core/base/note-height/get-fixed-note-height';

const MIN_SPACE = 20;
const MIN_CANVAS_HEIGHT = 167;

export interface ICanvasSize {
    top: number;
    left: number;
    width: any;
    scale: any;
    isShown: boolean;
    cTop: number;
    cLeft: number;
    height: any;
}

interface IOffsetDimension {
    offsetHeight: number;
    offsetWidth: number;
}

export default class PcCanvasSizeHandler implements ICanvasSizeHandler {
    private services?: IPcCanvasServiceDelegates;

    public setServices(services: IPcCanvasServiceDelegates) {
        this.services = {
            ...this.services,
            ...services,
        };
    }

    public getCurrentSlideBounds = (slideModel): ReadonlyBounds | undefined => this.services
        ?.pcEditorAreaService?.getCurrentSlideBounds(slideModel, this.services?.pcScrollService);

    public getComponentByModel = (model: IBaseModel): DisplayObject | undefined => this.services
        ?.pcEditorAreaService?.getComponentByModel(model);

    public getCanvasSize = (isHeaderFold, noteAreaInfo, isStatusBarFold): ICanvasSize => {
        const { offsetHeight, offsetWidth } = this.getCanvasOffsetHeightWidth(
            isHeaderFold,
            noteAreaInfo,
            isStatusBarFold,
        );
        const minSpace = MIN_SPACE;  // canvas和边框的最小间距
        const width = offsetWidth - minSpace * 2;
        const height = offsetHeight - minSpace * 2;
        const { slideWidth = 0, slideHeight = 0 } = this.services?.uiDataService?.presentation.props || { };
        const isAutoAdapter = this.services?.editAreaCanvasSizeManager?.getCanvasIsAutoAdapter();
        let left;
        let top;
        let scale;
        if (isAutoAdapter) {
            const xScale = width / slideWidth;
            const yScale = height / slideHeight;
            scale = Math.min(xScale, yScale);
            const scaleXOffset = width - (slideWidth * scale);
            const scaleYOffset = height - (slideHeight * scale);

            left = Math.floor(scaleXOffset / 2) + minSpace;
            top = Math.floor(scaleYOffset / 2) + minSpace;
        } else {
            scale = this.services?.editAreaCanvasSizeManager?.getCanvasScale();
            let scaleXOffset = width - (slideWidth * scale);
            let scaleYOffset = height - (slideHeight * scale);
            scaleXOffset = scaleXOffset < 0 ? 0 : scaleXOffset;
            scaleYOffset = scaleYOffset < 0 ? 0 : scaleYOffset;
            left = Math.floor(scaleXOffset / 2) + minSpace;
            top = Math.floor(scaleYOffset / 2) + minSpace;
        }
        const size = {
            canvasW: offsetWidth,
            canvasH: offsetHeight,
            left,
            top,
        };
        const newCanvasSize = this.computeElementCanvasSize(scale, size);
        return {
            width: newCanvasSize.canvasWidth,
            height: newCanvasSize.canvasHeight,
            left: left - newCanvasSize.canvasLeft,
            top: top - newCanvasSize.canvasTop,
            cLeft: newCanvasSize.canvasLeft,
            cTop: newCanvasSize.canvasTop,
            scale,
            isShown: true,
        };
    };

    public canvasSizeChange = (newCanvasSize, oldCanvasSize, containerDom) => {
        const params = ['width', 'height', 'left', 'top', 'scale'];
        let flag = false;
        params.forEach((param) => {
            if (!isNumberEqual(oldCanvasSize[param], newCanvasSize[param], 1e-10)) {
                flag = true;
            }
        });
        if (flag) {
            return true;
        }
        if (containerDom) {
            if (!isNumberEqual(containerDom.scrollLeft, -newCanvasSize.cLeft, 1e-10)) {
                return true;
            }
            if (!isNumberEqual(containerDom.scrollTop, -newCanvasSize.cTop, 1e-10)) {
                return true;
            }
        }
        return false;
    };

    /**
     * 获取wrapper区域（包括canvas与note-area）高度
     */
    public getWrapperHeightAndWidth = (): IOffsetDimension => {
        let offsetHeight = document.documentElement.clientHeight;
        let offsetWidth = document.documentElement.clientWidth;

        offsetWidth -= LEFT_BAR_WIDTH;
        offsetWidth -= this.getDrawerWidth();
        offsetWidth = Math.max(0, offsetWidth);
        offsetHeight -= (SINGLE_TOOLBAR_HEAD_HEIGHT + STATUS_BAR_HEIGHT + 1);

        offsetHeight = Math.max(0, offsetHeight);

        return {
            offsetHeight,
            offsetWidth,
        };
    };

    public getCanvasOffsetHeightWidth = (
        isHeaderFold: boolean,
        noteAreaInfo,
        isStatusBarFold = false,
    ): IOffsetDimension => {
        const MIN_WIDTH = 139;
        const MIN_HEIGHT = MIN_CANVAS_HEIGHT;
        let offsetHeight = document.documentElement.clientHeight;
        let offsetWidth = document.documentElement.clientWidth;
        const { noteAreaHeight } = noteAreaInfo;
        offsetWidth -= LEFT_BAR_WIDTH;
        offsetWidth -= this.getDrawerWidth();
        offsetWidth = Math.max(MIN_WIDTH, offsetWidth);
        const toolbarMode = this.services?.toolbarStateManager?.getToolbarMode();
        const isDoubleToolbar = toolbarMode === ToolbarType.DOUBLE_TOOLBAR;
        const toolbarHeight = isDoubleToolbar ? DOUBLE_TOOLBAR_HEAD_HEIGHT : SINGLE_TOOLBAR_HEAD_HEIGHT;
        const statusBarHeight = isStatusBarFold ? 0 : STATUS_BAR_HEIGHT;
        const nameToolHeight = this.getMasterLayoutEditService()?.isMasterEditType ? NAME_TOOL_HEIGHT : 0;
        offsetHeight -= (toolbarHeight + statusBarHeight + 1 - (isHeaderFold ? toolbarHeight : 0));
        offsetHeight -= nameToolHeight;

        offsetHeight = getHeightFixedByNoteHeight(offsetHeight, noteAreaHeight);
        offsetHeight = Math.max(MIN_HEIGHT, offsetHeight);

        if (this.getTextRulerManager()?.displayRuler) {
            offsetWidth -= RULER_LENGTH;
            offsetHeight -= RULER_LENGTH;
        }

        return {
            offsetHeight,
            offsetWidth,
        };
    };

    /**
     * 根据slide中元素的位置，重新计算宽高
     *
     */
    private computeElementCanvasSize = (scale, size) => {
        const {
            canvasW,
            canvasH,
            left: slideLeft,
            top: slideTop,
        } = size;
        let { slideWidth = 0, slideHeight = 0 } = this.services?.uiDataService?.presentation.props || { };

        const curSlide = this.services?.selectionService?.currentSlide;
        let newCanvasWidth = canvasW;
        let newCanvasHeight = canvasH;
        let canvasLeft = 0;
        let canvasTop = 0;
        if (curSlide?.children) {
            let { minLeft, maxRight, minTop, maxBottom } = this.computeMaxRect(curSlide);
            minLeft = Math.round(minLeft * scale);
            maxRight = Math.round(maxRight * scale);
            minTop = Math.round(minTop * scale);
            maxBottom = Math.round(maxBottom * scale);
            slideWidth = Math.round(slideWidth * scale) + MIN_SPACE * 2;
            slideHeight = Math.round(slideHeight * scale) + MIN_SPACE * 2;

            const slideCW = Math.max(slideWidth, canvasW);
            const slideCH = Math.max(slideHeight, canvasH);

            newCanvasWidth = slideCW;
            newCanvasHeight = slideCH;

            if (minLeft < 0 && Math.abs(minLeft) + MIN_SPACE > slideLeft) {
                const leftExtra = Math.abs(minLeft) - slideLeft + MIN_SPACE;
                newCanvasWidth += leftExtra;
                canvasLeft = -leftExtra;
            }
            if (maxRight + MIN_SPACE > slideCW - slideLeft) {
                newCanvasWidth += maxRight - (slideCW - slideLeft) + MIN_SPACE;
            }

            if (minTop < 0 && Math.abs(minTop) + MIN_SPACE > slideTop) {
                const topExtra = Math.abs(minTop) - slideTop + MIN_SPACE;
                newCanvasHeight += topExtra;
                canvasTop = -topExtra;
            }
            if (maxBottom + MIN_SPACE > slideCH - slideTop) {
                newCanvasHeight += maxBottom - (slideCH - slideTop) + MIN_SPACE;
            }
        }

        return {
            canvasLeft, canvasTop, canvasWidth: newCanvasWidth, canvasHeight: newCanvasHeight,
        };
    };

    private computeMaxRect(curSlide) {
        let minLeft = Number.MAX_VALUE;
        let maxRight = 0;
        let minTop = Number.MAX_VALUE;
        let maxBottom = 0;

        const rect = this.getCanvasElementRect?.(curSlide);
        if (rect) {
            minLeft = Math.min(minLeft, rect.left);
            maxRight = Math.max(maxRight, rect.left + rect.width);
            minTop = Math.min(minTop, rect.top);
            maxBottom = Math.max(maxBottom, rect.top + rect.height);
            curSlide.children.forEach((item) => {
                if (item.isGhostAttachment()) return;
                if (item?.props?.style && isDomCompatibleElement(item)) {
                    const newRect: any = this.getElementRect(item);
                    minLeft = Math.min(minLeft, newRect.left);
                    maxRight = Math.max(maxRight, newRect.left + newRect.width);
                    minTop = Math.min(minTop, newRect.top);
                    maxBottom = Math.max(maxBottom, newRect.top + newRect.height);
                }
            });
        } else {
            curSlide.children.forEach((item) => {
                if (item.isGhostAttachment()) return;
                if (item?.props?.style) {
                    const newRect: any = this.getElementRect(item);
                    minLeft = Math.min(minLeft, newRect.left);
                    maxRight = Math.max(maxRight, newRect.left + newRect.width);
                    minTop = Math.min(minTop, newRect.top);
                    maxBottom = Math.max(maxBottom, newRect.top + newRect.height);
                }
            });
        }

        return { minLeft, maxRight, minTop, maxBottom };
    }

    private getCanvasElementRect(slideModel) {
        const bounds = this.getCurrentSlideBounds?.(slideModel);
        if (!bounds || bounds.width === 0 || bounds.height === 0) {
            return;
        }

        const { x, y, width, height } = bounds;
        const {
            scale: storeScale,
        } = this.services?.editAreaCanvasSizeManager?.getCanvasSize() || { };
        const scale = storeScale || 1;
        const slideComponent = this.services?.pcEditorAreaService?.currentSlideEditor?.slideComponent;

        return {
            left: x / scale - (slideComponent?.x || 0),
            top: y / scale - (slideComponent?.y || 0),
            width: width / scale,
            height: height / scale,
        };
    }

    private getElementRect(item: any) {
        const { style } = item.props;
        let { left, top, width, height } = style;

        // 组合需要加上边框距离
        if (item.type === UIModelType.GROUP) {
            top -= GroupUIEdge;
            left -= GroupUIEdge;
            width += GroupUIEdge * 2;
            height += GroupUIEdge * 2;
        }

        const { rotate } = style;
        const oldReact = {
            left, top, width, height,
        };
        let newRect: any = oldReact;
        if (rotate && rotate > 0) {
            newRect = getFrameAfterRotate(oldReact, rotate);
        }
        return newRect;
    }

    private getDrawerWidth() {
        let offsetWidth = 0;
        const drawerStateManagerIns = this.services?.drawerStateManager?.dangerousInstance;
        if (drawerStateManagerIns?.isResizeDrawerShown()) {
            offsetWidth = drawerStateManagerIns?.getDrawerWidth() ?? 0;
        }
        return offsetWidth;
    }

    private getMasterLayoutEditService(): IMasterLayoutEditService | undefined {
        if (!this.services?.userPriviledgeService?.isEditable()) {
            return undefined;
        }
        return this.services?.masterLayoutEditService;
    }

    private getTextRulerManager(): ITextRulerManager | undefined {
        return this.services?.textRulerManager;
    }
}
